<section>
  <div class="form-register">
    <form [formGroup]="formInternalOrderDetail">
      <div class="row p-1">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-input-text class="border-radius-right" [disabled]="true" [labelText]="'Artículo'"
            [value]="codeNameArticle" [required]="true">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal ngDefaultControl formControlName="quantity" [labelText]="'Cantidad'"
            [required]="true" (onChangeNumber)="changeQuantity()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="totalAmountDeliveredQuantity" [labelText]="'Q.Salida Inv.'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="totalPurchaseOrderQuantity" [labelText]="'Q.Ord.Compra'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="pendingQuantity" [labelText]="'Q.Pendiente'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-6 checkbox-container d-flex align-items-center mt-3">
          <app-custom-checkbox formControlName="swUrgent" [labelText]="'Urgente'"></app-custom-checkbox>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 col-12 d-flex">
          <div class="d-flex align-items-end justify-content-end  gap-2 container-buttons bottom-0">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>